/**
 * Сеть перевода → название, как его пишут биржи в окне вывода.
 *
 * Бэкенд сводит имена сетей разных бирж к общим ключам (BSC, AVAX_C, ARB),
 * а родную сеть монеты — к «NATIVE»: у Gate она «COTI», у KuCoin «COTIEVM»,
 * и без общего ключа пересечение бы не находилось. Показывать эти ключи
 * человеку нельзя — «NATIVE» ни одна биржа не пишет.
 */
import i18n from '../i18n';

const CHAIN_NAMES: Record<string, string> = {
  ETH: 'Ethereum (ERC20)',
  BSC: 'BNB Smart Chain (BEP20)',
  TRX: 'Tron (TRC20)',
  SOL: 'Solana',
  TON: 'TON',
  ARB: 'Arbitrum One',
  OP: 'Optimism',
  POLYGON: 'Polygon',
  AVAX_C: 'Avalanche C-Chain',
  BASE: 'Base',
  EGLD: 'MultiversX',
  APT: 'Aptos',
  NEAR: 'NEAR',
  SUI: 'Sui',
  PLASMA: 'Plasma',
  KAIA: 'Kaia',
  KAVA: 'Kava',
  CELO: 'Celo',
  OPBNB: 'opBNB',
  SCROLL: 'Scroll',
  MANTLE: 'Mantle',
  HYPEREVM: 'HyperEVM',
  BERA: 'Berachain',
  STATEMINT: 'Polkadot Asset Hub',
  XLAYER: 'X Layer',
  BTC: 'Bitcoin',
  LTC: 'Litecoin',
  DOGE: 'Dogecoin',
  XRP: 'XRP Ledger',
  XLM: 'Stellar',
  ADA: 'Cardano',
  DOT: 'Polkadot',
  ATOM: 'Cosmos',
  ALGO: 'Algorand',
  XTZ: 'Tezos',
  EOS: 'EOS',
  HBAR: 'Hedera',
  SONIC: 'Sonic',
};

/** Родная сеть монеты: у главных монет — имя сети, у остальных — тикер
 *  (так её и называют биржи: «COTI», «INJ», «SEI»). */
const NATIVE_NAMES: Record<string, string> = {
  ETH: 'Ethereum (ERC20)', BNB: 'BNB Smart Chain (BEP20)', TRX: 'Tron (TRC20)',
  POL: 'Polygon', MATIC: 'Polygon', AVAX: 'Avalanche C-Chain',
  ARB: 'Arbitrum One', OP: 'Optimism', KLAY: 'Kaia', FTM: 'Fantom', S: 'Sonic',
};

export function chainName(key: string, coin?: string): string {
  const c = (coin || '').toUpperCase();
  if (key === 'NATIVE') return NATIVE_NAMES[c] || CHAIN_NAMES[c] || c || i18n.t('chains:nativeFallback');
  return CHAIN_NAMES[key] || key;
}
